import { AdvancedSearchModel } from "./advanced-search";
import {prop} from "../../decorators/property";

export class AdvancedSearchFilterModel extends Backbone.AssociatedModel {

    /** The display name for this filter */
    @prop() public DisplayName: string;
    /** The type of the filter e.g Report or Core */
    @prop() public Type: string;
    /** The value or code of the filter - e.g TLR */
    @prop() public Indicators: string[];

    /** Whether the checkbox is enabled (does the user have access to these cases) */
    @prop() public Enabled: boolean;
    /** if the checkbox is ticked or not */
    @prop() public Included: boolean;
    @prop() public Subscribed: boolean;

    @prop() public Coverage: string;

    @prop() public Description: string;

    @prop() public InfoUrl: string;

    @prop() public JurisdictionIds: number[];

    @prop() public SearchWithSubscription: boolean;

    public AdvancedSearch: AdvancedSearchModel; // Don't @Prop this. We shouldn't need to listen to it. @prop introduces circular reference in the attributes object, breaking backbone.model.save

    constructor(options?) {
        super(options);
    }

}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/search/models/advanced-search-filter.ts